import { Key, memo, useState } from "react";
import { Link } from "react-router-dom";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import Breadcrumb from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";

import { useConnectionStore } from "stores/ConnectionStore";
import { ActionState } from "stores/lib";

import { getSearchedServices } from "utility/connections";

import useAnalytics from "effect/use_analytics";

import Destinations from "external/destinations";

import LoaderModal from "layouts/components/LoaderModal";

import EnvironmentPossibleDestinations from "../Environment/Destinations/PossibleDestinations/Destination";

// -----------------------------------------------------------------------------

const EnvironmentDestinationsSearchPage = memo(
  function EnvironmentDestinationsSearchPage() {
    useAnalytics("Environment: Destinations Search");

    //
    const [connectionStore, connectionActions] = useConnectionStore();
    const [search, setSearch] = useState("");

    //
    if (connectionStore.loadConnections.state === ActionState.INITIAL) {
      connectionActions.loadConnections({ reload: true });
    }

    //
    const searchTermsRaw = search.toLocaleLowerCase().trim();
    const searchTerms = searchTermsRaw.length > 0 ? search.split(/\s+/g) : [];

    const services = Destinations.services;
    const destinations =
      searchTerms.length > 0
        ? getSearchedServices(services, searchTerms)
        : services;

    //
    return connectionStore.loadConnections.state === ActionState.IN_PROGRESS ? (
      <LoaderModal />
    ) : (
      <>
        <Breadcrumbs>
          <Breadcrumb
            underline="none"
            color="inherit"
            component={Link}
            to="/environment/destinations"
          >
            Environment
          </Breadcrumb>
          <Breadcrumb
            underline="none"
            color="inherit"
            component={Link}
            to="/environment/destinations"
          >
            Destinations
          </Breadcrumb>
          <span />
        </Breadcrumbs>
        <Typography variant="h4" fontWeight="bold" sx={{ mt: 1, mr: 1 }}>
          All Available Destinations
        </Typography>

        <TextField
          fullWidth
          variant="outlined"
          sx={{ mt: 2, backgroundColor: "#FFF" }}
          placeholder="Search destinations..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment:
              searchTerms.length > 0 ? (
                <InputAdornment position="end">
                  <CancelIcon
                    onClick={() => setSearch("")}
                    style={{ cursor: "pointer" }}
                  />
                </InputAdornment>
              ) : null,
          }}
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />

        {destinations.length > 0 ? (
          <Grid container spacing={1} sx={{ mt: 2 }}>
            {destinations.map(
              (destination: { name: Key | null | undefined }) => (
                <EnvironmentPossibleDestinations
                  destination={destination as any}
                  key={destination.name}
                  hideDismissButton
                />
              )
            )}
          </Grid>
        ) : (
          <Paper
            elevation={0}
            sx={{
              mt: 2,
              width: "100%",
              p: 4,
              background: "rgba(0, 0, 0, 0.1)",
              textAlign: "center",
            }}
          >
            No destinations found
          </Paper>
        )}
      </>
    );
  }
);

export default EnvironmentDestinationsSearchPage;
